// Auth.js
import './Auth.scss';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/logos/logo.svg';
import { jwtDecode } from 'jwt-decode';
// import AnimatedBackground from './AnimatedBackground';
import { AnimatedBackground } from 'animated-backgrounds';
import { setUserRole} from '../../storeRedux';
import { setProvider } from '../../storeRedux';
import { setUserName } from '../../storeRedux';
import { setUserID } from '../../storeRedux';
import { setUserRoleIncludeBoost } from '../../storeRedux';
import { setUserCode } from '../../storeRedux';
import { setReduxUserCanChangeAmount, setReduxUserCanSetMinOrders } from '../../storeRedux';
import { setClientAppTitle, setClientWelcomeMessage, setClientFavicon, setClientBackgroundAnimation, setClientBlendMode } from '../../storeRedux';

export default function Auth() {
    const { t } = useTranslation('auth');
    const dispatch = useDispatch();
    const api_url = useSelector((state) => state.API_URL);
    const navigate = useNavigate();
    // Настройки из ProjectSettings
    const client_welcome_message = useSelector((state) => state.CLIENT_WELCOME_MESSAGE);
    const client_background_animation = useSelector((state) => state.CLIENT_BACKGROUND_ANIMATION);
    const client_blend_mode = useSelector((state) => state.CLIENT_BLEND_MODE);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);

    // Загрузка публичных настроек при монтировании компонента
    useEffect(() => {
        const loadPublicSettings = async () => {
            try {
                const response = await fetch(api_url + 'public/settings/');
                if (response.ok) {
                    const data = await response.json();

                    // Dispatch настроек в Redux
                    if (data.client_app_title) {
                        dispatch(setClientAppTitle(data.client_app_title));
                        // Обновляем title страницы
                        document.title = data.client_app_title;
                        const metaDescription = document.querySelector('meta[name="description"]');
                        if (metaDescription) {
                            metaDescription.setAttribute('content', data.client_app_title);
                        }
                    }
                    if (data.client_welcome_message) dispatch(setClientWelcomeMessage(data.client_welcome_message));
                    if (data.client_favicon) {
                        dispatch(setClientFavicon(data.client_favicon));
                        // Обновляем favicon
                        let favicon = document.querySelector('link[rel="icon"]');
                        if (!favicon) {
                            favicon = document.createElement('link');
                            favicon.rel = 'icon';
                            document.head.appendChild(favicon);
                        }
                        favicon.href = data.client_favicon;
                    }
                    if (data.client_background_animation) dispatch(setClientBackgroundAnimation(data.client_background_animation));
                    if (data.client_blend_mode) dispatch(setClientBlendMode(data.client_blend_mode));
                }
            } catch (error) {
                // console.error('Error loading public settings:', error);
            }
        };

        loadPublicSettings();
    }, [api_url, dispatch]);

    const handleLoginChange = (event) => setUsername(event.target.value);
    const handlePasswordChange = (event) => setPassword(event.target.value);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleLogin({ username, password });
        }
    };

    const setReduxUserRole = (some_role) => {
        const newData = some_role;
        dispatch(setUserRole(newData));
    };

    const setReduxProvider = (some_provider) => {
        const newData = some_provider;
        dispatch(setProvider(newData));
    };

    const setReduxUserName = (username) => {
        const newData = username;
        dispatch(setUserName(newData));
    };

    const setUserIDFunc = (some_data) => {
        const newData = some_data;
        dispatch(setUserID(newData));
    };

    const setReduxUserRoleIncludesBoost = (some_role) => {
        const newData = some_role;
        dispatch(setUserRoleIncludeBoost(newData));
    };

    const setReduxUserCanChangeAmountFunc = (some_permission) => {
        const newData = some_permission;
        dispatch(setReduxUserCanChangeAmount(newData));
    };

    const setReduxUserCanSetMinOrdersFunc = (some_permission) => {
        const newData = some_permission;
        dispatch(setReduxUserCanSetMinOrders(newData));
    };

    const setReduxUserCode = (some_code) => {
        const newData = some_code;
        dispatch(setUserCode(newData));
    };

    const handleLogin = async ({ username, password }) => {
        const request = new Request(api_url + 'token/', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
    
        const response = await fetch(request);
        if (response.status < 200 || response.status >= 300) {
            setError(true);
            // сбросим всё из localStorage/sessionStorage
            localStorage.removeItem('persist:root');

            throw new Error(response.statusText);
        }
    
        const data = await response.json();
        // console.log(data);

        const { access, refresh } = data;
    
        // Декодирование access токена
        const decodedAccessToken = jwtDecode(access);
        // console.log('Decoded Access Token:', decodedAccessToken); // Выводим декодированные данные

        if (decodedAccessToken.groups.includes('Тимлид')) {
            setReduxUserRole('teamlead');
        } else if (decodedAccessToken.groups.includes('Трейдер')) {
            setReduxUserRole('operator');
        } else {
            // Панель доступна только трейдерам и тимлидерам
            setError(true);
            localStorage.removeItem('persist:root');
            return;
        }

        if (decodedAccessToken.groups.includes('BOOST')) {
            setReduxUserRoleIncludesBoost('yes');
        } else {
            setReduxUserRoleIncludesBoost('no');
        }

        if (decodedAccessToken.groups.includes('CHANGE_AMOUNT')) {
            setReduxUserCanChangeAmountFunc('yes');
        } else {
            setReduxUserCanChangeAmountFunc('no');
        }

        if (decodedAccessToken.groups.includes('MIN_USER_ORDERS')) {
            setReduxUserCanSetMinOrdersFunc('yes');
        } else {
            setReduxUserCanSetMinOrdersFunc('no');
        }

        setReduxProvider(decodedAccessToken.provider);
        setReduxUserName(decodedAccessToken.username);
        setUserIDFunc(decodedAccessToken.user_id);
        setReduxUserCode(decodedAccessToken.code);

        // Сохраняем токены
        localStorage.setItem('accessToken', access);
        localStorage.setItem('refreshToken', refresh);
        navigate('/');
    };
    
    
    const clientSidebarName = useSelector((state) => state.CLIENT_SIDEBAR_NAME);
    const clientSidebarSubtitle = useSelector((state) => state.CLIENT_SIDEBAR_SUBTITLE);

    return (
        <div className="Auth">
            <AnimatedBackground animationName={client_background_animation} vblendMode={client_blend_mode}/>
            <div className="auth-card">
                <div className="auth-card__brand">
                    <span className="auth-card__logo">{clientSidebarName || 'EXCHANGE'}</span>
                    <span className="auth-card__subtitle">{clientSidebarSubtitle || 'panel'}</span>
                </div>
                <p className="auth-card__welcome">{client_welcome_message}</p>
                <div className="auth-card__input-group">
                    <input
                        className="auth-card__input"
                        type="text"
                        placeholder={t('auth:login')}
                        value={username}
                        onChange={handleLoginChange}
                        onClick={() => setError(false)}
                        onKeyPress={handleKeyPress}
                    />
                    <input
                        className="auth-card__input"
                        type="password"
                        placeholder={t('auth:password')}
                        value={password}
                        onChange={handlePasswordChange}
                        onClick={() => setError(false)}
                        onKeyPress={handleKeyPress}
                    />
                </div>
                {error && <div className="auth-card__error">{t('auth:wrongCredentials')}</div>}
                <button className="auth-card__submit" onClick={() => handleLogin({username, password})}>
                    {t('auth:signIn')}
                </button>
            </div>
        </div>
    );
}
